<template>
  <div style="height: 100vh;" :style="{'background':row.show_bg}"> 
    <div class="machine-head"  :style="{'color':row.show_font_color}">
      <div>{{ row.title }}</div>
      <div>{{ row.saiqu_name }}</div>
    </div>

    <van-swipe v-if="row.show_jianlu_time>0" class="header-swiper" :autoplay="row.show_jianlu_time" indicator-color="FD2840">
      <van-swipe-item v-for="(sublist,key) in list" :key="key">
    <table class="machine-table" :style="'height:' + (clientHeight -104 - 50 -20) + 'px; overflow-y: auto;' ">
      <thead :style="{'background':row.show_bg_2,'color':row.show_font_color_2}">
      <tr>
        <th>次序</th>
        <th>项目名称</th>
        <th>单位名称</th>
       <th>状态</th>
<!--        <th>操作</th>-->
      </tr>
      </thead>
      <tbody :style="'height:' + (clientHeight  -104 - 50 - 20) + 'px; overflow-y: scroll;' ">
      <tr v-for="(item, index) in sublist" :key="index"  :style="{'color':row.show_font_color_2 ,'background':index%2==0?row.show_bg:row.show_bg_2}">
        <td>{{ item.index }}</td>
        <td>{{ item.subject_name }}</td>
        <td>{{ item.danwei }}</td>
       <td class="jianlu-status-cell">
            <span v-if="item.jianlu_status==0" class="jsl-st jsl-st--pending">待检录</span>
            <!-- <span class="jsl-st jsl-st--stage" v-else-if="item.jianlu_status==1" >检录1</span>
            <span class="jsl-st jsl-st--stage" v-else-if="item.jianlu_status==2">检录2</span>
            <span class="jsl-st jsl-st--stage" v-else-if="item.jianlu_status==3">检录3</span> -->
            <span v-else-if="item.jianlu_status==4" class="jsl-st jsl-st--signed">已签到</span>
            <span v-else-if="item.jianlu_status==5" class="jsl-st jsl-st--done-check">检录完成</span>
            <span v-else-if="item.jianlu_status==6" class="jianlu-status-zhenggai">
              <span class="jsl-st jsl-st--rectify">待整改</span>
              <span v-if="item.jianlu_note" class="jianlu-note-machine jsl-st-note">{{ item.jianlu_note }}</span>
            </span>
            <span v-else-if="item.jianlu_status==7" class="jsl-st jsl-st--match-done">比赛完成</span>
            <span v-else-if="item.jianlu_status==8" class="jsl-st jsl-st--forfeit">弃权</span>
            <span v-else-if="item.jianlu_status==9" class="jsl-st jsl-st--timeout">超时未到</span>
       </td>
<!--        <td>-->
<!--          <a @click="handleOpenArmy(item)">队伍信息</a>-->
<!--          <a-divider type="vertical"/>-->
<!--          <a @click="handleOpenRank(item)">分数</a>-->
<!--          <a-divider type="vertical"/>-->
<!--          <a @click="handleOpenSubjectRank(item)">项目排名</a>-->
<!--        </td>-->
      </tr>
      </tbody>

    </table>
      </van-swipe-item>
    </van-swipe>
    <audio
      ref="entranceAudio"
      preload="none"
      style="position:absolute;width:0;height:0;opacity:0;pointer-events:none"
      @ended="onEntranceAudioEnded"
      @error="onEntranceAudioError"
    />

    <van-dialog
      v-model="broadcastDialogShow" 
      width="70vw"
      class-name="jianlu-broadcast-machine-dialog"
      :show-confirm-button="false"
      :close-on-click-overlay="false"
    >
      <div
        v-if="broadcastPanel"
        class="jianlu-broadcast-dialog-shell"
        :style="broadcastDialogShellStyle"
      >
        <div class="jianlu-broadcast-titlebar" :style="broadcastDialogTitleStyle">
          请以下队伍入场
        </div>
        <div class="jianlu-broadcast-dialog-body" :style="broadcastDialogBodyStyle">
          <p>
            <span class="jianlu-broadcast-k" :style="broadcastDialogLabelStyle">次序</span>
            <span class="jianlu-broadcast-v">{{ broadcastPanel.index !== "" && broadcastPanel.index != null ? broadcastPanel.index : "—" }}</span>
          </p>
          <p>
            <span class="jianlu-broadcast-k" :style="broadcastDialogLabelStyle">项目名称</span>
            <span class="jianlu-broadcast-v">{{ broadcastPanel.subject_name || "—" }}</span>
          </p>
          <p>
            <span class="jianlu-broadcast-k" :style="broadcastDialogLabelStyle">单位名称</span>
            <span class="jianlu-broadcast-v">{{ broadcastPanel.danwei || "—" }}</span>
          </p>
          <p class="jianlu-broadcast-tip" :style="broadcastDialogTipStyle">
            {{ broadcastPlaybackEnded ? "播报已结束" : "正在语音播报…" }}
          </p>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<style scoped>
body {
  overflow-y: hidden;
}

.machine-table {
  width: 100%;
  /* color: #E3E59D; */
}

table th, table td {
  height: 50px;
  font-size: 16px;
  /*text-align: center;*/
  /*border: 1px solid gray;*/
}
::-webkit-scrollbar {
  width: 0px;
  /*background-color: transparent;*/
}

table td a {
  /* color: #E3E59D; */
}

table td a:hover {
  /* color: #F2EB92; */
  text-decoration: underline;
}

table td a.disabled {
  /* color: #999; */
}

table td a.disabled:hover {
  cursor: default;
  text-decoration: none;
}

table thead {
  /* color: white; */
  /* background-color: #0782B8; */
}

table tbody {
  display: block;
  /*width: calc(100% + 8px); !*这里的8px是滚动条的宽度*!*/
  height: 300px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

table thead tr, table tbody tr, table tfoot tr {
  box-sizing: border-box;
  table-layout: fixed;
  display: table;
  width: 100%;
}

table thead th:first-child {
  width: 100px;
  text-align: center;
}

table tbody td:first-child {
  text-align: center;
  width: 100px;
}

table thead th:nth-child(2) {
  text-align: left;
  width: 400px;
}

table tbody td:nth-child(2) {
  width: 400px;
}

table thead th:nth-child(3) {
  text-align: left;
  width: 360px;
}

table tbody td:nth-child(3) {
  width: 360px;
}

.machine-table tbody td:nth-child(4) {
  height: auto;
  min-height: 50px;
  vertical-align: middle;
  padding: 8px 6px;
}

/* 状态列：覆盖行内主题字色，按语义提高与深蓝/中蓝斑马底的对比度 */
.jianlu-status-cell {
  text-align: center;
}

.jsl-st {
  display: inline-block;
  font-weight: 700;
  letter-spacing: 0.02em;
}

/* 待检录：高亮浅字 + 细描边，避免灰字融进蓝底 */
.jsl-st--pending {
  color: #f8fafc !important;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.9), 0 1px 2px rgba(0, 0, 0, 0.45);
}

/* 已签到：亮黄绿（lime），与蓝底对比足够；与「检录完成」的翠绿区分开 */
.jsl-st--signed {
  color: #bef264 !important;
  text-shadow:
    0 0 1px rgba(0, 0, 0, 0.85),
    0 1px 3px rgba(0, 0, 0, 0.5);
}

/* 检录 1/2/3（若启用） */
.jsl-st--stage {
  color: #a5f3fc !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* 检录完成：高饱和绿 */
.jsl-st--done-check {
  color: #4ade80 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
}

/* 待整改：亮珊瑚红 */
.jsl-st--rectify {
  color: #ff8585 !important;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.85), 0 1px 2px rgba(0, 0, 0, 0.4);
}

.jsl-st-note {
  color: #fffbeb !important;
  opacity: 1 !important;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.75);
  font-weight: 600;
}

.jianlu-status-zhenggai {
  display: block;
  text-align: center;
}

.jianlu-note-machine {
  display: block;
  font-size: 13px;
  margin-top: 4px;
  line-height: 1.35;
  word-break: break-all;
}

/* 比赛完成：纯白加轻阴影 */
.jsl-st--match-done {
  color: #ffffff !important;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
}

/* 弃权：亮金黄，替代暗金色 */
.jsl-st--forfeit {
  color: #fcd34d !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.55);
}

/* 超时未到：警示红 */
.jsl-st--timeout {
  color: #ff6b6b !important;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.9), 0 1px 2px rgba(0, 0, 0, 0.4);
}

/*table thead th:nth-child(4) {*/
/*  width: 100px;*/
/*}*/

/*table tbody td:nth-child(4) {*/
/*  width: 100px;*/
/*}*/

/*table thead th:first-child, table tbody td:first-child{*/
/*  padding-left: 30px;*/
/*}*/

table tr:nth-child(even) {
  /* background: #0782B8; */
}

.pointer {
  cursor: pointer;
}

.machine-head {
  /*background: url("../../assets/icon-machine-bg.png") no-repeat;*/
  /*background-size: 100% 205px;*/
  /*height: 205px;*/
  padding: 13px 0;
  text-align: center;
  font-size: 26px;
  /* color: #fff; */
  font-weight: 500;
}

.machine-content {
  margin: 30px 30px 0;
}

.machine-content-left {
  width: 75%;
}

.machine-content-operate {
  display: flex;
  flex-wrap: wrap;
}

.machine-li {
  width: 20%;
  text-align: center;
}

.machine-li-box {
  margin: 0 10px 10px 0;
  /* background: #fff; */
  overflow: hidden;
  border-radius: 10px;
}

.caipan-info {
  padding: 10px 0;
  cursor: pointer;
}

.caipan-info-disabled {
  /* background: #EEEEEE; */
}

.caipan-name {
  font-weight: 500;
  color: #4A4A4A;
}

.caipan-score {
  font-size: 30px;
  font-weight: 500;
  color: #000;
  font-family: DINAlternate-Bold, DINAlternate;
}

.caipan-comment {
  /* color: #9B9B9B; */
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caipan-button {
  padding: 0 5px;
  height: 35px;
  width: 100%;
}

.caipan-button-active {
  background: #1F85E2;
}

.caipan-button-score {
  background: #0EB791;
  cursor: pointer;
}

.caipan-button-disabled {
  background: #9B9B9B;
}

.caipan-button-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  height: 35px;
  cursor: pointer;
  color: #fff;
}

.caipan-machine-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  color: #fff;
  height: 35px;
  cursor: pointer;
}

.caipan-button-li img, .caipan-machine-li img {
  width: 14px;
  margin-right: 5px;
}

.jianlu-broadcast-dialog-shell {
  border-radius: 4px;
  overflow: hidden;
  min-width: 72vw;
  max-width: 90vw;
}

.jianlu-broadcast-titlebar {
  padding: 14px 20px;
  font-size: 24px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 2px;
}

.jianlu-broadcast-dialog-body {
  padding: 20px 24px 28px;
  font-size: 22px;
  line-height: 1.6;
  text-align: left;
}

.jianlu-broadcast-dialog-body p {
  margin: 0 0 16px;
  word-break: break-all;
}

.jianlu-broadcast-k {
  display: inline-block;
  min-width: 5em;
  margin-right: 12px;
  font-size: 22px;
  font-weight: 500;
  vertical-align: top;
}

.jianlu-broadcast-v {
  font-size: 22px;
  vertical-align: top;
}

.jianlu-broadcast-tip {
  margin-top: 22px !important;
  margin-bottom: 0 !important;
  font-size: 20px;
  text-align: center;
  opacity: 0.95;
}

</style>

<!-- 弹窗挂载到 body，需非 scoped 才能覆盖 Vant 默认白底 -->
<style>
.jianlu-broadcast-machine-dialog.van-dialog {
  background: transparent;
  top: 45%;
}
.jianlu-broadcast-machine-dialog .van-dialog__header {
  display: none;
}
.jianlu-broadcast-machine-dialog .van-dialog__content {
  padding: 0;
  background: transparent;
}
</style>
<script>
import Vue from "vue";
import {
  Swipe,
  SwipeItem,
  Dialog,
} from "vant";
Vue.use(Swipe)
  .use(SwipeItem)
export default {
  name: 'ScoreStartList',
  components: {
    Dialog,
  },
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Object,
      default: () => []
    },
    /** 来自 scoreStartSubjectList 轮询：{ voiceUrl, token, danwei, index, subject_name } */
    broadcast: {
      type: Object,
      default: null
    },
    startId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      broadcastDialogShow: false,
      broadcastPanel: null,
      broadcastPlaybackEnded: false,
      broadcastCloseTimer: null,
      lastBroadcastToken: '',
      loading: false,
      saveLoading: false,
      drawerVisible: false,
      scoreVisible: false,
      rankVisible: false,
      dataVisible: false, // 修改数据
      currentFilter: false,
      currentCpIndex: 0,
      row: {
      },

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },

      dataColumns: [],
      clientHeight: 0
    }

  },
  mounted() {
    const that = this

    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;

  },
  destroyed() {
    this.clearBroadcastCloseTimer()
  },
  computed: {
    broadcastDialogShellStyle() {
      const r = this.row || {}
      return {
        boxShadow: "0 8px 32px rgba(0,0,0,0.35)",
      }
    },
    /** 与表头行一致 */
    broadcastDialogTitleStyle() {
      const r = this.row || {}
      return {
        background: r.show_bg_2 || "#143a5c",
        color: r.show_font_color_2 || "#E3E59D",
      }
    },
    /** 与表格斑马纹首行底色一致 */
    broadcastDialogBodyStyle() {
      const r = this.row || {}
      return {
        background: r.show_bg || "#0d2840",
        color: r.show_font_color_2 || "#E3E59D",
      }
    },
    /** 标签偏亮，接近大屏标题字色 */
    broadcastDialogLabelStyle() {
      const r = this.row || {}
      return {
        color: r.show_font_color || "#ffffff",
      }
    },
    broadcastDialogTipStyle() {
      const r = this.row || {}
      return {
        color: r.show_font_color_2 || "#E3E59D",
        opacity: this.broadcastPlaybackEnded ? 0.85 : 1,
      }
    },
  },
  watch: {
    broadcast: {
      deep: true,
      handler(val) {
        if (!val || !val.voiceUrl || !val.token) {
          return
        }
        if (val.token === this.lastBroadcastToken) {
          return
        }
        this.clearBroadcastCloseTimer()
        this.broadcastPlaybackEnded = false
        this.lastBroadcastToken = val.token
        this.broadcastPanel = {
          danwei: val.danwei || '',
          index: val.index != null && val.index !== '' ? val.index : '',
          subject_name: val.subject_name || '',
          token: val.token,
        }
        this.broadcastDialogShow = true
        this.$nextTick(() => {
          this.playEntranceVoice(val.voiceUrl)
        })
      }
    }
  },
  methods: {
    playEntranceVoice(url) {
      const el = this.$refs.entranceAudio
      if (!el || !url) {
        return
      }
      el.src = url
      el.currentTime = 0
      const p = el.play()
      if (p && typeof p.catch === 'function') {
        p.catch(() => {
          this.onEntranceAudioError()
        })
      }
    },
    clearBroadcastCloseTimer() {
      if (this.broadcastCloseTimer) {
        clearTimeout(this.broadcastCloseTimer)
        this.broadcastCloseTimer = null
      }
    },
    /** 播报结束或失败后，延迟 3 秒再关弹窗并 ack，避免刷新重复播 */
    scheduleBroadcastClose() {
      this.clearBroadcastCloseTimer()
      this.broadcastPlaybackEnded = true
      this.broadcastCloseTimer = setTimeout(() => {
        this.broadcastCloseTimer = null
        this.broadcastDialogShow = false
        this.requestBroadcastAck()
      }, 3000)
    },
    onEntranceAudioEnded() {
      this.scheduleBroadcastClose()
    },
    onEntranceAudioError() {
      this.scheduleBroadcastClose()
    },
    requestBroadcastAck() {
      const panel = this.broadcastPanel
      const sid = Number(this.startId) || 0
      if (!panel || !panel.token || !sid) {
        this.broadcastPanel = null
        return
      }
      const token = panel.token
      this.broadcastPanel = null
      this.$api.post(
        '/api/dscore/jianluBroadcastAck',
        { start_id: sid, token },
        () => {},
        () => {}
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// ScoreJianluList.vue?51de1532